import styled from "styled-components";

export const HiddenForm = styled.form`
  display: none;
`;
